import React, { useEffect } from "react";
import { useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';
import Industries from "../components/Industries";
import '../assets/css/tech-repair.css';

const About = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Breadcrumb Hero Section */}
      <section className="breadcrumb-hero">
        <div className="breadcrumb-overlay"></div>
        <div className="breadcrumb-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="breadcrumb-title">
                  About <span className="breadcrumb-highlight">CLOUD MIND X</span>
                </h1>
                <button className="breadcrumb-btn">
                  <span>CONNECT NOW</span>
                  <span className="breadcrumb-arrow">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="breadcrumb-pattern"></div>
      </section>

      {/* Technology Repair Section - Same Design as Image */}
      <section className="tech-repair-section">
        <div className="container-fluid">
          <div className="row align-items-center g-0">
            {/* Left Content */}
            <div className="col-lg-6 tech-repair-left">
              <div className="tech-repair-content">
                <div className="tech-repair-tagline">
                  <span className="tech-repair-line"></span>
                  <span className="tech-repair-text">TECHNOLOGY REPAIR</span>
                </div>
                <h2 className="tech-repair-title">
                  ABOUT US
                </h2>
                <p className="tech-repair-description">
                  CLOUD MIND X is a forward-thinking IT company delivering smart, reliable, and scalable digital solutions. We help businesses grow by transforming ideas into powerful websites, mobile apps, and custom software using modern technology and innovative thinking.
                </p>
                <button className="tech-repair-btn">
                  <span>KNOW MORE</span>
                  <span className="tech-repair-arrow">
                    <svg width="20" height="12" viewBox="0 0 20 12" fill="none">
                      <path d="M1 6H19M19 6L14 1M19 6L14 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
              </div>

              {/* Circuit Board Pattern - Left Side */}
              <div className="circuit-pattern-left">
                <svg className="circuit-svg" viewBox="0 0 300 500" fill="none">
                  <circle cx="30" cy="30" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="30" cy="100" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="30" cy="170" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="100" cy="30" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="100" cy="100" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="100" cy="170" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="170" cy="30" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="170" cy="100" r="3" fill="#00D9FF" opacity="0.6" />
                  <circle cx="170" cy="170" r="3" fill="#00D9FF" opacity="0.6" />
                  <line x1="30" y1="30" x2="30" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="30" y1="100" x2="30" y2="170" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="100" y1="30" x2="100" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="100" y1="100" x2="100" y2="170" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="170" y1="30" x2="170" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="170" y1="100" x2="170" y2="170" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="30" y1="30" x2="100" y2="30" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="100" y1="30" x2="170" y2="30" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="30" y1="100" x2="100" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  <line x1="100" y1="100" x2="170" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                </svg>
              </div>

              {/* Bottom Corner Circuit */}
              <div className="circuit-corner-bottom">
                <svg width="150" height="150" viewBox="0 0 150 150" fill="none">
                  <path d="M0 150 L0 120 L30 120 L30 90 L60 90" stroke="#00D9FF" strokeWidth="2" opacity="0.4" />
                  <circle cx="60" cy="90" r="4" fill="#00D9FF" opacity="0.6" />
                  <circle cx="30" cy="120" r="4" fill="#00D9FF" opacity="0.6" />
                </svg>
              </div>
            </div>

            {/* Right Content - Hexagon Icons & Image */}
            <div className="col-lg-6 tech-repair-right">
              <div className="tech-repair-visual">
                {/* Hexagon Icon 1 - Desktop */}
                <div className="tech-hexagon tech-hex-1">
                  <div className="hexagon-shape">
                    <svg viewBox="0 0 100 100" className="hexagon-bg">
                      <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="#00D9FF" opacity="0.15" />
                      <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="none" stroke="#00D9FF" strokeWidth="2" />
                    </svg>
                    <div className="hexagon-icon">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                        <line x1="2" y1="19" x2="22" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <line x1="8" y1="19" x2="16" y2="19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Hexagon Icon 2 - Mobile */}
                <div className="tech-hexagon tech-hex-2">
                  <div className="hexagon-shape">
                    <svg viewBox="0 0 100 100" className="hexagon-bg">
                      <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="#00D9FF" opacity="0.15" />
                      <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="none" stroke="#00D9FF" strokeWidth="2" />
                    </svg>
                    <div className="hexagon-icon">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="2" />
                        <line x1="12" y1="18" x2="12" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Hexagon Icon 3 - Database */}
                <div className="tech-hexagon tech-hex-3">
                  <div className="hexagon-shape">
                    <svg viewBox="0 0 100 100" className="hexagon-bg">
                      <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="#00D9FF" opacity="0.15" />
                      <polygon points="50,5 95,27.5 95,72.5 50,95 5,72.5 5,27.5" fill="none" stroke="#00D9FF" strokeWidth="2" />
                    </svg>
                    <div className="hexagon-icon">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <ellipse cx="12" cy="6" rx="8" ry="3" stroke="currentColor" strokeWidth="2" />
                        <path d="M4 6v6c0 1.657 3.582 3 8 3s8-1.343 8-3V6" stroke="currentColor" strokeWidth="2" />
                        <path d="M4 12v6c0 1.657 3.582 3 8 3s8-1.343 8-3v-6" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* Main Tech Image with Hexagon Frame */}
                <div className="tech-main-image">
                  <div className="tech-image-hexagon">
                    <svg viewBox="0 0 500 500" className="image-hexagon-frame">
                      <defs>
                        <clipPath id="hexClip">
                          <polygon points="250,20 470,145 470,395 250,520 30,395 30,145" />
                        </clipPath>
                      </defs>
                      <polygon points="250,20 470,145 470,395 250,520 30,395 30,145" fill="none" stroke="#00D9FF" strokeWidth="4" opacity="0.6" />
                    </svg>
                    <img
                      src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                      alt="Technology Repair Professional"
                      className="tech-repair-img"
                    />
                  </div>
                </div>

                {/* Circuit Pattern - Right Side */}
                <div className="circuit-pattern-right">
                  <svg className="circuit-svg" viewBox="0 0 300 500" fill="none">
                    <circle cx="270" cy="30" r="3" fill="#00D9FF" opacity="0.6" />
                    <circle cx="270" cy="100" r="3" fill="#00D9FF" opacity="0.6" />
                    <circle cx="270" cy="170" r="3" fill="#00D9FF" opacity="0.6" />
                    <circle cx="200" cy="30" r="3" fill="#00D9FF" opacity="0.6" />
                    <circle cx="200" cy="100" r="3" fill="#00D9FF" opacity="0.6" />
                    <circle cx="200" cy="170" r="3" fill="#00D9FF" opacity="0.6" />
                    <line x1="270" y1="30" x2="270" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                    <line x1="270" y1="100" x2="270" y2="170" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                    <line x1="200" y1="30" x2="270" y2="30" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                    <line x1="200" y1="100" x2="270" y2="100" stroke="#00D9FF" strokeWidth="1" opacity="0.3" />
                  </svg>
                </div>

                {/* Animated Arrows */}
                <div className="tech-arrows">
                  <div className="arrow-line arrow-1"></div>
                  <div className="arrow-line arrow-2"></div>
                  <div className="arrow-line arrow-3"></div>
                  <div className="arrow-line arrow-4"></div>
                  <div className="arrow-line arrow-5"></div>
                  <div className="arrow-line arrow-6"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="about-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mt-4 mt-md-0">
              <h2 className="display-6 fw-bold text-white mb-2" style={{ textAlign: 'left' }}>About Us</h2>

              <p className="text-muted mb-4">
                We are Gemperts a premier technology consulting firm specializing in offering cutting-edge IT solutions and services with a special forte in Artificial Intelligence and Cybersecurity. Our aim is to bring about optimized operational efficiency and induce healthy growth patterns for businesses coming from a broad spectrum of business domains. We combine deep domain expertise with next-gen technologies and empower business houses to excel in the age of digitalization.
              </p>

              <button
                className="btn-common btn-common-primary btn--lg clickcustomform wow fadeInU"
                style={{ visibility: "visible", animationName: "button", height: '50px', fontSize: '20px', textAlign: 'center' }}
              >
                <span>Contact Us</span>
                <span className="button-icon-container arrow-white">
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    className="shrink-0 fill-btn-hover-content transition-all motion-reduce:transition-none duration-500 ease-in-out group-hover:ml-0 -ml-8 mr-0"
                  >
                    <g fill="inherit">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.085 10.8333L9.42356 14.5731C9.04929 14.9553 9.04929 15.5667 9.42356 15.949C9.8092 16.3429 10.4433 16.3429 10.8289 15.949L15.965 10.703C16.345 10.3148 16.345 9.68553 15.965 9.29737L10.8289 4.05105C10.4433 3.65715 9.80921 3.65713 9.42356 4.05101C9.04928 4.43328 9.04926 5.04462 9.42352 5.42691L13.0847 9.16666L4.58333 9.16666C4.1231 9.16666 3.75 9.53976 3.75 10C3.75 10.4602 4.1231 10.8333 4.58333 10.8333L13.085 10.8333Z"
                      ></path>
                    </g>
                  </svg>

                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    className="shrink-0 mx-0 fill-btn-content"
                  >
                    <g fill="inherit">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.085 10.8333L9.42356 14.5731C9.04929 14.9553 9.04929 15.5667 9.42356 15.949C9.8092 16.3429 10.4433 16.3429 10.8289 15.949L15.965 10.703C16.345 10.3148 16.345 9.68553 15.965 9.29737L10.8289 4.05105C10.4433 3.65715 9.80921 3.65713 9.42356 4.05101C9.04928 4.43328 9.04926 5.04462 9.42352 5.42691L13.0847 9.16666L4.58333 9.16666C4.1231 9.16666 3.75 9.53976 3.75 10C3.75 10.4602 4.1231 10.8333 4.58333 10.8333L13.085 10.8333Z"
                      ></path>
                    </g>
                  </svg>
                </span>
              </button>
            </div>
            <div className="col-md-6">
              <div className="about-image-container">
                <div className="about-shape-1"></div>
                <div className="about-shape-2"></div>
                <div className="about-shape-3"></div>

                <div className="about-image-wrapper">
                  <img
                    src="https://cdn.quantiphi.com/2025/04/About-Us-716x471-1.webp"
                    alt="workspace"
                    className="about-main-image"
                  />

                  <div className="about-stats-overlay">
                    <div className="row g-3">
                      <div className="col-4">
                        <div className="about-stat-item">
                          <span className="about-stat-number">50+</span>
                          <span className="about-stat-label">Projects</span>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="about-stat-item">
                          <span className="about-stat-number">15+</span>
                          <span className="about-stat-label">Clients</span>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="about-stat-item">
                          <span className="about-stat-number">5+</span>
                          <span className="about-stat-label">Years</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section> */}


      <section className="services-section py-5">
        <div className="container">
          <div className="text-center mb-4 mb-lg-5">
            <h2 className="display-6 fw-bold text-white mb-2">
              Our Services Designed to Drive Growth
            </h2>
            <p className="text-muted lead m-0">
              Discover our full suite of capabilities that accelerate your digital transformation journey.
            </p>
          </div>

          <div className="row">
            {/* {services.map((s, idx) => ( */}
            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/app.png')} /> </div>
                <h3 className="service-title text-white">Mobile App Development</h3>
                <p className="service-desc m-0">We specialize in creating Native and cross-platform apps that deliver seamless user experiences.</p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/ai-ml.png')} /></div>
                <h3 className="service-title text-white">Expert team</h3>
                <p className="service-desc m-0">Expert team with backgrounds in data science, ML, and product design.</p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/chip.png')} /></div>
                <h3 className="service-title text-white">AI & ML Solutions</h3>
                <p className="service-desc m-0">We integrate AI & ML to craft intelligent solutions that automate workflows and elevate decision making.</p>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/ai-stack.png')} /></div>
                <h3 className="service-title text-white">AI Stack</h3>
                <p className="service-desc m-0">Industry-ready tools and cutting-edge AI stack.</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/mvp.png')} /></div>
                <h3 className="service-title text-white">MVP Development</h3>
                <p className="service-desc m-0">We ensure rapid development, user validation, and a flawless launch experience.</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/blockchain.png')} /></div>
                <h3 className="service-title text-white">Digital Marketing</h3>
                <p className="service-desc m-0">We are building dApps and smart contracts tailored for industries such as finance and logistics.</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/consultant.png')} /></div>
                <h3 className="service-title text-white">IT Consulting</h3>
                <p className="service-desc m-0">We provide professional IT consulting services to help your business align IT strategies with business objectives.</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-3 mt-3">
              <div className="service-card h-100 d-flex flex-column">
                <div className="service-icon mb-3"><img src={require('../assets/images/services/cloud-server.png')} /></div>
                <h3 className="service-title text-white">DevOps</h3>
                <p className="service-desc m-0">Our DevOps services provide reliable, and scalable infrastructure with automated deployments.</p>
              </div>
            </div>
            {/* ))} */}
          </div>

        </div>
      </section>

      <section className="cyber-who-we-are-section" style={{
        backgroundImage: 'linear-gradient(135deg, rgba(13, 27, 62, 0.95), rgba(24, 42, 79, 0.92)), url(https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        position: 'relative',
        padding: '100px 0',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          right: '10%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(74, 144, 226, 0.15), transparent)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '10%',
          left: '10%',
          width: '250px',
          height: '250px',
          background: 'radial-gradient(circle, rgba(0, 188, 212, 0.15), transparent)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 8s ease-in-out infinite reverse'
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          {/* Title Section */}
          <div className="text-center mb-5" style={{
            animation: 'fadeInDown 1s ease-out'
          }}>
            <p style={{
              color: '#4a90e2',
              fontSize: '0.9rem',
              fontWeight: '600',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '15px'
            }}>YOUR DIGITAL DEFENSE PARTNER</p>
            <h2 style={{
              color: '#ffffff',
              fontSize: '3.5rem',
              fontWeight: '800',
              marginBottom: '20px',
              textShadow: '2px 2px 20px rgba(74, 144, 226, 0.3)',
              letterSpacing: '-1px'
            }}>
              Who We Are
            </h2>
            <div style={{
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #4a90e2, #00bcd4)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>

          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                padding: '40px',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease'
              }}>
                <p style={{
                  color: '#ffffff',
                  fontSize: '1.2rem',
                  lineHeight: '2',
                  marginBottom: '25px',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  textAlign: 'left'
                }}>
                  <span style={{
                    color: '#4a90e2',
                    fontWeight: '700',
                    fontSize: '1.3rem',
                    textShadow: '0 0 10px rgba(74, 144, 226, 0.5)',

                  }}>CLOUD MIND X</span> is more than just a cybersecurity company - we are your trusted digital security partner.
                </p>
                <p style={{
                  color: '#e8f0ff',
                  fontSize: '1.1rem',
                  lineHeight: '1.9',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  textAlign: 'left'
                }}>
                  Our team of certified security professionals, ethical hackers, and technology strategists brings extensive hands-on experience in defending businesses against evolving cyber threats. By combining deep human expertise with advanced security technologies, we deliver proactive, real-time protection that safeguards your digital assets and ensures business continuity.                </p>

                {/* Stats Section */}
                <div className="row mt-4 g-3">
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                      <h3 style={{
                        color: '#4a90e2',
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                        textShadow: '0 0 20px rgba(74, 144, 226, 0.6)'
                      }}>7+</h3>
                      <p style={{ color: '#fff', fontSize: '0.9rem', margin: 0 }}>Years Experience</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                      <h3 style={{
                        color: '#00bcd4',
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                        textShadow: '0 0 20px rgba(0, 188, 212, 0.6)'
                      }}>500+</h3>
                      <p style={{ color: '#fff', fontSize: '0.9rem', margin: 0 }}>Clients Protected</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                      <h3 style={{
                        color: '#4a90e2',
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                        textShadow: '0 0 20px rgba(74, 144, 226, 0.6)'
                      }}>99.9%</h3>
                      <p style={{ color: '#fff', fontSize: '0.9rem', margin: 0 }}>Success Rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content - Sectors */}
            <div className="col-lg-6">
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                padding: '40px',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
              }}>
                <h4 style={{
                  color: '#ffffff',
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  marginBottom: '30px',
                  textShadow: '1px 1px 10px rgba(74, 144, 226, 0.3)'
                }}>
                  We serve clients across sectors:
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {[
                    { icon: '🏦', text: 'Banking & Finance' },
                    { icon: '🏥', text: 'Healthcare & Pharmaceuticals' },
                    { icon: '🏭', text: 'Manufacturing & Supply Chain' },
                    { icon: '🛒', text: 'E-commerce & Retail' },
                    { icon: '🏛️', text: 'Government & Public Sector' }
                  ].map((item, index) => (
                    <li key={index} style={{
                      padding: '18px 20px',
                      marginBottom: '12px',
                      background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.1), rgba(0, 188, 212, 0.05))',
                      borderRadius: '12px',
                      fontSize: '1.15rem',
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid rgba(74, 144, 226, 0.2)',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateX(10px)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(74, 144, 226, 0.2), rgba(0, 188, 212, 0.1))';
                        e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateX(0)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(74, 144, 226, 0.1), rgba(0, 188, 212, 0.05))';
                        e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.2)';
                      }}>
                      <span style={{
                        fontSize: '1.8rem',
                        marginRight: '20px',
                        filter: 'drop-shadow(0 0 5px rgba(74, 144, 226, 0.5))'
                      }}>{item.icon}</span>
                      <span style={{
                        color: '#ffffff',
                        fontWeight: '500',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
                      }}>{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>


      </section>

      {/* Mission, Values, Vision Section - New Professional Design */}
      <section className="mvv-section-new">
        <div className="mvv-animated-bg">
          <div className="mvv-floating-shape mvv-shape-1"></div>
          <div className="mvv-floating-shape mvv-shape-2"></div>
          <div className="mvv-floating-shape mvv-shape-3"></div>
        </div>

        <div className="container">
          {/* Section Header */}
          <div className="mvv-header">
            <span className="mvv-subtitle">OUR CORE PRINCIPLES</span>
            <h2 className="mvv-title">Mission • Vision • Values</h2>
            <p className="mvv-description">
              The three pillars that define who we are and guide everything we do
            </p>
          </div>

          {/* MVV Cards Grid */}
          <div className="mvv-grid">
            {/* Mission Card */}
            <div className="mvv-card-new mvv-mission">
              <div className="mvv-card-glow"></div>
              <div className="mvv-card-content">
                <div className="mvv-icon-wrapper">
                  <div className="mvv-icon-bg"></div>
                  <svg className="mvv-icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" opacity="0.3" />
                    <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="2" opacity="0.5" />
                    <circle cx="32" cy="32" r="12" stroke="currentColor" strokeWidth="2" />
                    <circle cx="32" cy="32" r="4" fill="currentColor" />
                    <line x1="32" y1="4" x2="32" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="32" y1="52" x2="32" y2="60" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="4" y1="32" x2="12" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="52" y1="32" x2="60" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <h3 className="mvv-card-title">Mission</h3>
                <p className="mvv-card-text">
                  To empower businesses with innovative technology solutions that drive growth,
                  efficiency, and digital transformation in an ever-evolving landscape.
                </p>
                <div className="mvv-card-number">01</div>
              </div>
            </div>

            {/* Vision Card */}
            <div className="mvv-card-new mvv-vision">
              <div className="mvv-card-glow"></div>
              <div className="mvv-card-content">
                <div className="mvv-icon-wrapper">
                  <div className="mvv-icon-bg"></div>
                  <svg className="mvv-icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 20C20 20 10 32 10 32C10 32 20 44 32 44C44 44 54 32 54 32C54 32 44 20 32 20Z" stroke="currentColor" strokeWidth="2" />
                    <circle cx="32" cy="32" r="8" stroke="currentColor" strokeWidth="2" />
                    <circle cx="32" cy="32" r="4" fill="currentColor" />
                    <path d="M28 28L24 24M36 28L40 24M28 36L24 40M36 36L40 40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </div>
                <h3 className="mvv-card-title">Vision</h3>
                <p className="mvv-card-text">
                  To become a global leader in technology innovation, recognized for delivering
                  cutting-edge solutions that shape the future of digital business.
                </p>
                <div className="mvv-card-number">02</div>
              </div>
            </div>

            {/* Values Card */}
            <div className="mvv-card-new mvv-values">
              <div className="mvv-card-glow"></div>
              <div className="mvv-card-content">
                <div className="mvv-icon-wrapper">
                  <div className="mvv-icon-bg"></div>
                  <svg className="mvv-icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="12" y="12" width="40" height="40" rx="4" stroke="currentColor" strokeWidth="2" />
                    <path d="M22 32L28 38L42 24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="16" cy="16" r="2" fill="currentColor" />
                    <circle cx="48" cy="16" r="2" fill="currentColor" />
                    <circle cx="16" cy="48" r="2" fill="currentColor" />
                    <circle cx="48" cy="48" r="2" fill="currentColor" />
                  </svg>
                </div>
                <h3 className="mvv-card-title">Values</h3>
                <p className="mvv-card-text">
                  Excellence, integrity, innovation, and customer-centricity form the foundation
                  of everything we do, ensuring sustainable success for all stakeholders.
                </p>
                <div className="mvv-card-number">03</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Industries />

    </>
  );
};

export default About;
